new Vue({
  el: '#threeLogin',
  delimiters: ['${', '}'],
  mixins: [mixin],
  data() {
    return {
      loginErrorTip: '',
      twitterAPIKey: '',
      facebookAPIKey: '',
      ModalFlag: 0,
      sandboxUrls: [
        {
          url: 'account/login',
          twitterAPIKey: 'QaKiozP50RTETSxncI9Pz3vmH'
        },
        {
          url: 'account/register',
          twitterAPIKey: 'RHnEu6cpiKGucTUvOkrSzA2WA'
        },
        // {
        //   url: 'pages/kitchen-progress',
        //   twitterAPIKey: '6mVi57flOjmyLQ9NJK693XDpA'
        // },
      ],
      hostUrls: [
        {
          url: 'account/login',
          twitterAPIKey: 'IHrI0q2HzXXGiDdjh4QjYT1dz'
        },
        {
          url: 'account/register',
          twitterAPIKey: 'j48axO5bpw5u3RuPa5pQa3PtD'
        },
      ]
    }
  },
  created() {
    this.getUrl()
    console.log(this.twitterAPIKey)
    console.log(this.facebookAPIKey)
  },
  methods: {
    getUrl() {
      let host = ''
      let urls = []
      // 沙盒
      if (window.Shopify.shop.indexOf('pro') > -1) {
        host = 'https://pro-ikich.myshopify.com/'
        urls = this.sandboxUrls
        this.facebookAPIKey = '790495121463117'
        // 沙盒
      } else {
        host = 'https://www.ikich.com/'
        this.facebookAPIKey = '469629827086193'
        urls = this.hostUrls
      }
      for (let i = 0; i < urls.length; i++) {
        const element = urls[i];
        let urlNow = window.location.href
        if (urlNow.indexOf(host + element.url) > -1) {
          this.twitterAPIKey = element.twitterAPIKey
        }
      }
    },
    // 第三方登录
    getMediaLogin(data) {
      this.loginErrorTip = ''
      let url = apiHost + 'api/shop/social/media/login';
      let account = ''
      let is_true = 1
      if (data.account && data.account.indexOf('@') > -1) {
        account = data.account
      } else {
        account = data.id + '_0_#' + (data.login_source == 'facebook' ? 'fb@ikich.com' : 'tw@ikich.com')
        is_true = 0
      }
      let obj = {
        account: account,
        login_source: data.login_source,
        source: data.source,
        is_true: is_true,
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        phone: '',
        gender: '',
        birthday: '',
        country: ''
      }
      window.plugin.ajax(url, obj)
        .then(res => {
          if (res.code == 1) {
            var password = '';
            if (res.data.is_default) {
              // 拼接密码
              let key = `5${data.account}${data.login_source}md5sat${res.data.rand_key}`;
              let md_key = md5(key);
              // 取前面6位  和后面 3位
              password = md_key.substring(0, 6) + data.account.substring(0, 3);
            } else {
              let key = window.plugin.base64Encode(res.data.password);
              password = key.substring(12, key.length - 50);
            }
            let form = {
              account: account,
              password: password
            }
            // 调用登录方法
            this.threeLogin(form, res.data.is_default);
          } else {
            this.loginErrorTip = res.msg
          }
          
        }).catch(err => { })
    },
    // 第三方登录接口
    threeLogin(form, is_default) {
      window.plugin.shopiyfLogin(form).then(res => {
        let errArr = $($.parseHTML(res)).find('#customer_login .errors')
        if (errArr.length > 0) {
          this.loginErrorTip = errArr[0].innerText;
        } else {
          console.log('ss')
          // dataLayer.push({ 'event': 'invite2.0', 'invite2.0-name': 'invite2.0-login' });
          // alert('111')
          // window.location.reload()
          window.location.href = '/account'
        }
      })
    },
    // 登录
  }
})